import type { RouteRecordRaw } from 'vue-router';

export const messageRoutes: Array<RouteRecordRaw> = [
  {
    path: '/trade/message',
    name: 'tradeMessage',
    redirect: '/trade/message/list',
    component: () => import('pages/trade/admin/message/McMessage.vue'),
    meta: {
      title: 'Messages',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeMessageList',
        component: () => import('pages/trade/admin/message/MessageList.vue'),
        meta: {
          title: 'Messages List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeMessageDetail',
        component: () => import('pages/trade/admin/message/MessageDetail.vue'),
        meta: {
          title: 'Message Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeMessageNew',
        component: () => import('pages/trade/admin/message/MessageNew.vue'),
        meta: {
          title: 'New Message',
          requiresAuth: true,
        },
      },
    ],
  },
];
